module.exports = __webpack_public_path__ + "static/assets/6b2189582da05ce371706002b31ae3d5.png";